<template>
  <div class="full-width full-height position-relative">
    <div class="overflow-hidden position-absolute full-width">
      <div class="d-flex align-center">
        <span
          v-if="item.option.showCount"
          class="mr-1 font-weight-bold"
          style="width: 31px"
          >[{{ item.meta.featuresCount }}]</span
        >
        <span
          class="text-caption d-inline-block text-truncate flex-grow-1"
          :title="item.name"
          @click="$emit('click', item)"
        >
          <span>{{ item.name }}</span>
        </span>
        <div class="d-flex flex-grow-0 align-center">
          <base-button
            class="mr-2"
            icon
            small
            :tooltip="$t('map.layer.action.change-style')"
            @click.stop="onToggleShowSelectLayer()"
          >
            <v-icon small>mdi-layers</v-icon>
          </base-button>
          <base-button
            class="mr-2"
            icon
            small
            :tooltip="
              isShow
                ? $t('map.layer.action.hide-layer')
                : $t('map.layer.action.show-layer')
            "
            @click.stop="toggleShow"
          >
            <v-icon v-if="isShow" small>mdi-eye</v-icon>
            <v-icon v-else small>mdi-eye-off</v-icon>
          </base-button>
          <base-button
            v-if="item.meta.bbox"
            class="mr-2"
            icon
            small
            :tooltip="$t('map.layer.action.fillbound')"
            @click.stop="callAction('click:fillbound')"
          >
            <v-icon small>mdi-crosshairs-gps</v-icon>
          </base-button>
          <base-button
            class="mr-2"
            icon
            small
            :tooltip="$t('map.layer.action.delete-layer')"
            @click.stop="$emit('click:delete', item)"
          >
            <v-icon small>mdi-delete</v-icon>
          </base-button>
          <slot name="extra-btn"></slot>
          <v-menu
            bottom
            left
            v-if="
              (item.meta.menus && item.meta.featuresCount.length > 0) ||
                item.meta.featuresCount
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" small v-on="on">
                mdi-dots-vertical
              </v-icon>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(menu, i) in item.meta.menus"
                :key="i"
                @click="menu.handler(item)"
              >
                <v-list-item-title>
                  <trans-field transable :value="menu"></trans-field>
                </v-list-item-title>
              </v-list-item>
              <template v-if="item.meta.featuresCount">
                <v-list-item
                  v-if="item.option.showCount"
                  @click="callAction('click:hide-count')"
                >
                  <v-list-item-title>
                    {{ $t('map.layer.action.hide-count') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-else @click="callAction('click:show-count')">
                  <v-list-item-title>
                    {{ $t('map.layer.action.show-count') }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
    <div class="pt-7">
      <div class="d-flex align-center">
        <div class="flex-grow-0 d-flex align-center justify-center">
          <v-icon>mdi-map</v-icon>
        </div>
        <v-slider
          v-model="opacity"
          dense
          height="20px"
          hide-details
          max="1"
          min="0"
          small
          step="0.1"
          thumb-label
          :thumb-size="24"
          track-color="#eeeeee"
        ></v-slider>
      </div>
    </div>
  </div>
</template>

<script>
import { get, set } from 'lodash'
export default {
  components: {},
  props: {
    item: { type: Object, required: true },
    isCompare: Boolean,
    isSelected: Boolean,
  },
  computed: {
    isShow() {
      return (
        !this.item.style.layout ||
        !this.item.style.layout.visibility ||
        this.item.style.layout.visibility == 'visible'
      )
    },
    style: {
      get() {
        return this.item.meta.styles_geoserver
      },
      set(value) {
        this.item.meta.styles_geoserver = value
        this.callAction('update:style')
      },
    },
    keyOpactiy() {
      return `style.paint.${this.item.style.type}-opacity`
    },
    opacity: {
      get() {
        return get(this.item, this.keyOpactiy, 1)
      },
      set(value) {
        let item = this.item
        set(item, this.keyOpactiy, value)
        this.$emit('update:item', item)
      },
    },
  },
  data: () => ({ menuShow: false }),
  watch: {},
  methods: {
    toggleShow() {
      this.$emit('click:action', {
        type: 'click:show',
        data: this.item,
        value: !this.isShow,
      })
    },
    callAction(type) {
      this.$emit('click:action', { type, data: this.item })
    },
    onToggleShowSelectLayer() {
      this.callAction('click:show-layers')
    },
  },
}
</script>

<style scoped lang="scss">
.layer-item {
  position: relative;
  .draggable-handle {
    cursor: all-scroll;
    width: 20px;
    height: 100%;
  }
}
.layer-active {
  outline: 1px solid var(--v-primary-base) !important;
}
</style>
<style scoped>
::v-deep .v-slider.v-slider--horizontal {
  min-height: 20px;
}
</style>
